import isAfter from 'date-fns/isAfter'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

type isAfterDateType = (
  date: dateParamType,
  dateToCompare: dateParamType,
) => boolean

const isAfterDate: isAfterDateType = (dateProp, dateToCompareProp) => {
  const date = toDate(dateProp)
  const dateToCompare = toDate(dateToCompareProp)
  const results = isAfter(date, dateToCompare)
  return results
}

export default isAfterDate
